var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloseIconDialog = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0028 12.3509L19.7774 6.57617L21.4273 8.22608L15.6527 14.0008L21.4273 19.7755L19.7774 21.4254L14.0028 15.6507L8.22804 21.4254L6.57812 19.7755L12.3529 14.0008L6.57812 8.22608L8.22804 6.57617L14.0028 12.3509Z",
    fill: "#424242"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseIconDialog, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-icon-dialog.67b09b32.svg";
export { ForwardRef as ReactComponent };